

































export default {
  name: "BaseMediaTimeSlider",
  components: {},
  data: function () {
    return {
      isGrabbing: false,
      timeBeforeGrabbing: 0,
      collectedMovementX: 0,
      isShowModal: false,
      isActive: false,
    };
  },
  computed: {
    progressLeft: function () {
      let percentFromLeft = 0;
      if (this.isGrabbing) {
        percentFromLeft =
          (this.timeBeforeGrabbing * 100) / this.duration +
          (this.collectedMovementX / this.$refs.player.offsetWidth) * 100;
      } else {
        percentFromLeft = (this.currentTime * 100) / this.duration;
      }
      return percentFromLeft < 0
        ? percentFromLeft
        : percentFromLeft > 100
        ? 100
        : percentFromLeft + "%";
    },
  },
  mounted: function () {},
  props: {
    duration: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: Number,
      required: true,
    },
  },
  methods: {
    clickOnProgressBar(event) {
      let fullWidth = event.target.getBoundingClientRect().width;
      let clickWidth = event.offsetX;
      let progress = clickWidth / fullWidth;

      this.$emit("timeChanged", this.duration * progress);
    },
    startGrab(event) {
      event.stopPropagation();
      this.isGrabbing = true;
      this.timeBeforeGrabbing = this.currentTime;
      window.onmousemove = this.moveCursorAt.bind(event);
      window.onmouseup = this.stopGrab.bind(event);
      this.$emit("startDragPlayhead");

      this.isActive = true;
    },
    moveCursorAt(event) {
      this.collectedMovementX += event.movementX;

      let newTime =
        this.timeBeforeGrabbing +
        (this.collectedMovementX / this.$refs.player.offsetWidth) *
          this.duration;
      this.$emit(
        "timeChanged",
        newTime < 0 ? 0 : newTime > this.duration ? this.duration : newTime
      );
    },
    stopGrab() {
      this.isGrabbing = false;
      this.collectedMovementX = 0;
      this.timeBeforeGrabbing = 0;
      window.onmouseup = null;
      window.onmousemove = null;
      this.$emit("stopDragPlayhead");
      this.onMouseUp();
    },
    onMouseOut() {
      if (this.isActive) {
        this.isShowModal = true;
      }
    },
    onMouseUp() {
      if (this.isActive) {
        this.isActive = false;
        this.isShowModal = false;
      }
    },
  },
};
